import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Chip,
  Grid,
} from '@mui/material';
import { ApiParameter } from '../../../../types/admin';

interface ParameterInputsProps {
  title: string;
  parameters: ApiParameter[];
  values: Record<string, string>;
  onParameterChange: (name: string, value: string) => void;
  disabled?: boolean;
}

export const ParameterInputs: React.FC<ParameterInputsProps> = ({
  title,
  parameters,
  values,
  onParameterChange,
  disabled = false,
}) => {
  if (!parameters || parameters.length === 0) {
    return null;
  }

  const getInputType = (type: string) => {
    switch (type) {
      case 'number':
        return 'number';
      case 'boolean':
        return 'text';
      default:
        return 'text';
    }
  };

  const getHelperText = (param: ApiParameter) => {
    let text = param.description;
    if (param.type === 'boolean') {
      text += ' (enter "true" or "false")';
    }
    if (!param.required) {
      text += ' (optional - leave empty for null)';
    }
    return text;
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Grid container spacing={2}>
        {parameters.map((param) => (
          <Grid item xs={12} sm={6} md={4} key={param.name}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Typography variant="body2" fontWeight="medium">
                {param.name}
              </Typography>
              {param.required && (
                <Chip label="Required" size="small" color="error" variant="outlined" />
              )}
              <Chip label={param.type} size="small" color="info" variant="outlined" />
            </Box>
            <TextField
              fullWidth
              size="small"
              type={getInputType(param.type)}
              value={values[param.name] || ''}
              onChange={(e) => onParameterChange(param.name, e.target.value)}
              placeholder={param.placeholder}
              helperText={getHelperText(param)}
              disabled={disabled}
              variant="outlined"
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};